import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { ImageDate } from '../models/imageDate';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { DataDisplayerBase } from '../data-displayer-base';

@Component({
  selector: 'app-dates-display',
  templateUrl: './dates-display.component.html',
  styleUrls: ['./dates-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatesDisplayComponent extends DataDisplayerBase<ImageDate> implements OnInit {

  @Output() handleEndOfData: EventEmitter<any> = new EventEmitter<any>();

  public showQtr = false;

  public ordinalSuffix = WriteOrdinalSuffixOfNumber;

  private page = 1;

  private rpp = 100;

  ngOnInit() {
    if (this.columns.length > 3) {
      this.showQtr = true;
    }
  }

  onScroll(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight && this.data.length % this.rpp === 0) {
      this.handleEndOfData.emit(++this.page);
    }
  }

}
